export const formatFriendlyDate = (date?: Date) => {
  if (!date || isNaN(date.getTime())) {
    return undefined;
  }
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}_${hours}-${minutes}`;
};

export const parseFriendlyDate = (dateStr: string) => {
  const isValid = /^\d{4}-\d{2}-\d{2}_\d{2}-\d{2}$/.test(dateStr);
  if (!isValid) return undefined;
  const [datePart, timePart] = dateStr.split('_');
  const isoString = `${datePart}T${timePart.replace('-', ':')}:00Z`;
  return new Date(isoString);
};

export function updateUrlParam(key: string, value?: string) {
  const params = new URLSearchParams(window.location.search);
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  const paramsStr = params.toString();
  const newUrl = !paramsStr ? window.location.pathname : `${window.location.pathname}?${paramsStr}`;

  window.history.pushState({ ...params }, '', newUrl);
}
